import React from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import ConfirmDialog from './ConfirmDialog';

/**
 * "Do you want to logout?" — shared by the CRM header and the partner header,
 * built on the common ConfirmDialog so it matches the portal's other
 * confirmation popups (e.g. Communication Hub's resend).
 */
export default function LogoutConfirmDialog({ open, onCancel, onConfirm }) {
  return (
    <ConfirmDialog
      open={open}
      title="Logout"
      message="Do you want to logout?"
      confirmLabel="Logout"
      confirmIcon={<LogoutIcon />}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
